// @flow

// Skipping story doc and test coverage for this component since it is not possible to do it correctly
/* eslint-disable ta-code-conventions/has-matching-storydoc */
/* eslint-disable ta-code-conventions/has-matching-test */
/* istanbul ignore file */

import Logging from '@ta/common.logging';
import { mark, logSsrMetric } from '@ta/platform.performance';

// eslint-disable-next-line no-restricted-imports
import { getStore, initializeStore } from '@ta/common.state';

/**
 * Function to force the queue of batched requests to be fulfilled.
 */
export default () => {
  if (!global || !global.callbackUniqueId) {
    // Frontend didn't give us a callback id, so don't try to call back to fulfill data API
    return Promise.resolve(false);
  }
  const start = Date.now();
  mark('dataApiStart');
  const state = getStore().getState();
  return microservices
    .dataApiBatched(state)
    .then(response => {
      if (!response) {
        throw new Error(`Undefined response from data API after ${Date.now() - start} ms`);
      }
      const parsedResponse = JSON.parse(response);
      initializeStore(parsedResponse);
      logSsrMetric('global', 'dataApi-time', Date.now() - start);
      logSsrMetric('global', 'dataApi-count', 1);
      mark('dataApiEnd');
      return true;
    })
    .catch(err => {
      Logging.warn(`Exception in DataApiFulfiller:`, err);
      logSsrMetric('global', 'dataApiError-time', Date.now() - start);
      logSsrMetric('global', 'dataApiError-count', 1);
      mark('dataApiErr');
      return false;
    });
};
